export default __webpack_public_path__ + "static/media/emanuel.32a359e3.jpg";